import { Env } from "../constants/env";
import { $axios } from "../constants/axios.instance";

const MFA_TOKEN_KEY = "mfaToken";
const AUTH_TOKEN_KEY = "auth_token";
const USER_LOGGED_IN_KEY = "isUserLoggedIn";
const ACCESS_TOKEN_HEADER = "access-token";

/**
 * Sets or clears the access token header on the shared axios instance.
 * Passing a falsy value removes the header entirely.
 */
export const setAuthorizationToken = (token?: string) => {
  if (token) {
    $axios.defaults.headers.common[ACCESS_TOKEN_HEADER] = token;
    return;
  }

  delete $axios.defaults.headers.common[ACCESS_TOKEN_HEADER];
};

/**
 * Clears all session data, including axios auth headers, and forces a reload.
 * Prefer this over `localStorage.clear()` elsewhere to keep the app state in sync.
 */
export const removeSession = () => {
  localStorage.clear();
  setAuthorizationToken("");
  window.location.reload();
};

/**
 * Retrieves the auth token from localStorage and primes axios with it.
 */
export const getSetAccessToken = () => {
  const accessToken = localStorage.getItem(AUTH_TOKEN_KEY);
  if (accessToken) {
    setAuthorizationToken(accessToken);
  }
  return accessToken;
};

/**
 * Persists the auth token (when present) and primes axios headers.
 */
export const setAccessToken = (accessToken: string) => {
  if (accessToken) {
    localStorage.setItem(AUTH_TOKEN_KEY, accessToken);
    setAuthorizationToken(accessToken);
  }
  return accessToken;
};

/**
 * Reads the dynamic auth token used for API authentication.
 */
export const getAccessToken = () => {
  const tokenObjectString = localStorage.getItem(
    `dynamic_${Env.ENVIRONMENT_ID}_session`,
  );
  const tokenObject = tokenObjectString && JSON.parse(tokenObjectString);
  const token = tokenObject?.value?.legacyToken;
  return token;
};

/**
 * Returns the login-state flag stored after authentication.
 */
export const checkUserLoggedIn = () => {
  return localStorage.getItem(USER_LOGGED_IN_KEY);
};

/**
 * Retrieves the MFA token saved during multi-factor flows.
 */
export const getMFAtoken = () => {
  return localStorage.getItem(MFA_TOKEN_KEY);
};
